import PromiseUtility from "../../../../utility/promiseUtility";
import Q2SeatCardsBase from "./q2_seat_cards_base";
import { Card } from "./q2_card_common";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import { HorizontalDirection, VerticalDirection } from "../../../table/module/poker_table/poker_seat_pokers_base";

const { ccclass, property, menu } = cc._decorator;

@ccclass
export default class Q2SeatCards extends Q2SeatCardsBase{

    @property(cc.Node)
    nodeFromFaPaiPos: cc.Node = null

    @property(cc.Float)
    fapaiFadeInDuration: number = 0.2

    @property(cc.Float)
    fapaiMoveDuration: number = 0.2

    @property(cc.Label)
    labelLeftCount: cc.Label = null

    @property(cc.Node)
    nodeWarning: cc.Node = null

    @property(cc.Node)
    nodeBg: cc.Node = null

    playFaPaiAnim(codeList: number[], onFinish?: Function){
        let self = this
        self.removeAllPokers()
        let pokers = self.genPokerList(codeList, false, true)
        let len = pokers.length
        let animList = []
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            poker.showFace(poker.code != 0)
            poker.showBack(poker.code == 0)
            poker.node.position = self.getFaiPaiStartPos(poker.node)
            poker.node.zIndex = index
            let targetPos = self.calcPos(index, 0, len, 1)
            let tmpFun = function(cb){
                self.playFadeAnim(poker.node, 0, 255, self.fapaiFadeInDuration, null, ()=>{
                    self.playNodeAnim(poker.node, targetPos, 1, 0, self.fapaiMoveDuration, null, cb, cc.easeBackOut())
                })
            }
            animList.push(tmpFun)
        }
        PromiseUtility.all(animList).then(function(){
            onFinish && onFinish()
        })
    }

    playCardInAnim(codeList: number[], onFinish?: Function){
        let self = this
        let pokers = self.genPokerList(codeList, true, true)
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            poker.showFace(poker.code != 0)
            poker.showBack(poker.code == 0)
            poker.node.position = self.getFaiPaiStartPos(poker.node)
        }
        this.pokers.sort(function(a, b){            
            let cardA = Card.makeCardByCode(a.code)
            let cardB = Card.makeCardByCode(b.code)
            return cardB.index - cardA.index
        })
        this.playAdjust(null, onFinish)
    }

    playCardOutAnim(codeList: number[], onFinish?: Function){
        let self = this
        let pokerList = []
        let pokers = this.pokers
        for (let i = 0; i < codeList.length; i++) {
            const code = codeList[i];
            let logicCode = Card.codeToLogicCode(code)
            let hasCode = false
            for (let index = pokers.length - 1; index >= 0; index--) {
                const poker = pokers[index];                                
                if(Card.codeToLogicCode(poker.code) == logicCode){
                    hasCode = true
                    pokers.splice(index, 1)
                    pokerList.push(poker)
                    break
                }
            }
            if(!hasCode){
                logicCode = 0
                for (let index = pokers.length - 1; index >= 0; index--) {
                    const poker = pokers[index];                                
                    if(Card.codeToLogicCode(poker.code) == logicCode){                        
                        pokers.splice(index, 1)
                        pokerList.push(poker)
                        break
                    }
                }
            } 
        }
        
        for (let index = 0; index < pokerList.length; index++) {
            const poker = pokerList[index];
            let targetPos = this.getFaiPaiStartPos(poker.node)
            self.playFadeAnim(poker.node, 255, 0, self.fapaiFadeInDuration)
            self.playNodeAnim(poker.node, targetPos, 1, 0, self.fapaiMoveDuration, null, function(){
                poker.node.opacity = 255
                poker.hide()
                self.pushToUnUseedList(self.m_unUseedHandPokers, poker)
            })
        }
        self.playAdjust(null, onFinish)
    }

    showLeftCardCount(show: boolean, count?: number){
        this.labelLeftCount.node.active = !!show
        if(show){
            this.labelLeftCount.string = `${count}`
        }        
        if(show && count <= 3 && count > 0){
            this.labelLeftCount.node.active = false
            this.showWarningIcon(true)
        }else{
            this.showWarningIcon(false)
        }
    }

    showWarningIcon(show: boolean){
        this.nodeWarning.active = !!show
    }

    showBg(show: boolean){
        this.nodeBg.active = !!show
    }

    protected getFaiPaiStartPos(node: cc.Node){
        return node.parent.convertToNodeSpaceAR(this.nodeFromFaPaiPos.parent.convertToWorldSpaceAR(this.nodeFromFaPaiPos.position))
    }

    protected calcPos(col: number, row: number, totalColCount: number, totalRowCount: number): cc.Vec2{           
        //最上面为第0行，最左边为第0列
        let centerCol = ((totalColCount - 1) * 0.5)
        let centerRow = ((totalRowCount - 1) * 0.5)
        let pos = cc.v2(0, 0)
        let intervalX = this.getIntervalX(totalColCount, totalRowCount)
        pos.x = intervalX * col
        if(this.horizontalDirection == HorizontalDirection.CenterToMargin){
            pos.x = intervalX * (col - centerCol)
        }else if(this.horizontalDirection == HorizontalDirection.LeftToRight){
            pos.x = intervalX * col
        }else if(this.horizontalDirection == HorizontalDirection.RightToLeft){
            pos.x = intervalX * (col - (totalColCount - 1))
        }
        pos.x += this.getOffsetX(totalColCount, totalRowCount)
        let q2Count = this.getQ2PokerCount()
        if(intervalX < this.intervalX && q2Count > 0){
            let colList = [0, 1]            
            
            let extendCount = q2Count           
            let tmpOffset = this.intervalX - intervalX
            let extendOffset = tmpOffset * extendCount
            extendOffset = extendOffset / (totalColCount - q2Count - 1)
            for (let index = 0; index < q2Count; index++) {
                const tmpCol = colList[index];
                if(col > tmpCol){
                    pos.x += tmpOffset
                }                
            }
            if(col > q2Count){
                pos.x -= (extendOffset * (col - q2Count))
            }
        }
        let intervalY = this.getIntervalY(totalColCount, totalRowCount)
        pos.y = intervalY * row
        if(this.verticalDirection == VerticalDirection.CenterToMargin){
            pos.y = intervalY * (centerRow - row)
        }else if(this.verticalDirection == VerticalDirection.TopToBottom){
            pos.y = intervalY * (-row)
        }else if(this.verticalDirection == VerticalDirection.BottomToTop){
            pos.y = intervalY * ((totalRowCount - 1) - row)
        }
        pos.y += this.getOffsetY(totalColCount, totalRowCount)
        return pos
    }

    protected getQ2PokerCount(): number{
        let pokers = this.pokers
        let count = 0
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            if(Card.isQ2(poker.code)){
                count++
            }
        }
        return count
    }
}
